import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

/** 与管理员操作日志列表「详情」可用性一致：为 true 时不展示详情入口 */
export function isAdminLogDetailDisabled (row: {
  first_model: string | number
  second_model: string | number
}): boolean {
  const firstModels = [4]
  const secondModels = [1, 2, 3, 4, 5, 6, 7, 9, 41, 42, 48, 58]
  return firstModels.includes(+row.first_model)
    || secondModels.includes(+row.second_model)
}

export const SECOND_MODEL_PATH = {
  43: '/dashboard/software-disabled',
  45: '/dashboard/process-control',
  46: '/dashboard/screen-watermark',
  47: '/dashboard/genuine-software',
  30: '/dashboard/traffic-control',
  31: '/dashboard/access-restriction',
  34: '/dashboard/usb-policy',
  49: '/dashboard/file-control-strategy-setting',
  51: '/dashboard/file-whitelist',
  52: '/dashboard/asset-registration',
  54: '/dashboard/cascade-branch-overview',
  55: '/dashboard/cascade-manage',
  56: '/dashboard/cascade-approval',
  60: '/dashboard/ip-address-blocking',
  65: '/dashboard/remote-authentication',
}

export interface FetchOptions {
  key_word?: string // 关键词搜索
  start_time?: number // 开始时间
  end_time?: number // 结束时间
  first_model_id?: number // 一级模块
  second_model_id?: number // 二级模块
  admin_uid?: number // 管理员uid
  page: number // 页码
  limit: number // 每页数量
}

export interface LogItem {
  record_id: string // 记录id
  admin_id: string // 管理员id
  admin_name: string // 管理员名
  first_model: string // 一级模块
  second_model: string // 二级模块
  operation: string // 操作行为
  /** 操作模板编号 1–68，对应 noticeManage.adminOperationActions */
  template_id?: number
  /** 模板占位符 JSON 字符串，如 {"admin_name":"1956"} */
  variables?: string
  /** 兼容旧字段名 */
  opt_type?: string | number
  opt_data?: string | Record<string, unknown>
}

export interface Models {
  model_id: number // 模块id
  model_name: string // 模块名
  models: Models[] // 二级模块
}

@Injectable()
export class AdminOperationLogService {
  constructor (private http: Http) {

  }

  fetchAdminModelData () {
    return this.http
      .post<{
        models: Models[],
        secondModels: Models[],
        firstModelIdMap: Record<string, unknown>,
        secondModelIdMap: Record<string, unknown>
      }>('/logmanage/admin-opt/model', {})
      .then(response => {
        let secondModels: Models[] = []
        const firstModelIdMap = {}
        const secondModelIdMap = {}

        response.models.forEach(item => {
          firstModelIdMap[item.model_id] = item.model_name
          secondModels = secondModels.concat(item.models)
          item.models.forEach(sub => {
            secondModelIdMap[sub.model_id] = sub.model_name
          })
        })

        Object.assign(response, {
          secondModels,
          firstModelIdMap,
          secondModelIdMap
        })

        return response
      })
  }

  @ParamsClean()
  @InvokeThrottle()
  fetchAdminOperationLogData (options: FetchOptions) {
    return this.http
      .post<{
        total: number
        list: LogItem[]
      }>('/logmanage/admin-operation/list', options)
  }
  download (type: 0|1, options: FetchOptions, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/logmanage/admin-operation/list/export', params, moduleName)
  }
}
